export default __webpack_public_path__ + "static/award-2023-II-e6833cc5d692a94928a3a43f5056aa1b.png";